import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class RecordDetailFormsAssetFormatComponent extends Component {
  <template>
    <InfoBox @type='warning'>
      {{t 'record_detail.forms.asset_format.asset_token_config_hint'}}
    </InfoBox>

    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />
            <fieldset.field @property='name' @disabled={{not @model.isNew}} />
            <fieldset.field @property='label' />
            <fieldset.field @property='description' @type='textarea' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='configuration' as |fieldset|>
            <fieldset.field
              @property='width'
              @type='number'
              @disabled={{not @model.isNew}}
            />
            <fieldset.field
              @property='height'
              @type='number'
              @disabled={{not @model.isNew}}
            />
            <fieldset.field @property='commandTemplate' @type='textarea' />
            <fieldset.field @property='isDownloadFormat' @type='checkbox' />
            <fieldset.field @property='isCroppingFormat' @type='checkbox' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
